/**
 * Day-0 (first-run onboarding) rule.
 *
 * `lastAccessedAt` comes from the auth (verify/login) response — the decision is
 * made once, at login. A first-ever login has no prior access, so the value is
 * null/empty; that's when the Day-0 landing is shown (at `/`).
 *
 * `DEMO_DAY0` is a supported QA/demo override: set
 * `localStorage.setItem("DEMO_DAY0", "1")` to force Day-0 regardless of the
 * timestamp; remove it to restore the normal rule.
 */

export const DEMO_DAY0_KEY = "DEMO_DAY0";

/** True when the timestamp represents a first-ever access (null/empty/0). */
export function isFirstAccess(lastAccessedAt?: number | null): boolean {
  return lastAccessedAt == null || lastAccessedAt === 0;
}

/** True when the DEMO_DAY0 QA/demo override is enabled. */
export function isDay0Forced(): boolean {
  return (
    typeof localStorage !== "undefined" &&
    localStorage.getItem(DEMO_DAY0_KEY) === "1"
  );
}
